import { createRouter, createWebHistory, createWebHashHistory } from 'vue-router'
import sessionManager from '@/utils/login/sessionManager'
import LoginForm from '@/components/LoginForm.vue'

const MonitorConsole = () => import('@/views/MonitorConsole.vue')

const routes = [
  {
    path: '/',
    name: 'Login',
    component: LoginForm,
    meta: { guestOnly: true }
  },
  {
    path: '/monitor',
    name: 'MonitorConsole',
    component: MonitorConsole,
    meta: { requiresAuth: true }
  },
  {
    path: '/fall-replay',
    name: 'FallReplay',
    component: () => import('@/views/FallReplay.vue'),
    meta: { requiresAuth: true }
  }
]

// Tauri / 相对路径部署必须使用 hash 路由（BASE_URL 在生产环境为 '' 而非 './'）
const useHashHistory = process.env.NODE_ENV === 'production'

const router = createRouter({
  history: useHashHistory
    ? createWebHashHistory()
    : createWebHistory(process.env.BASE_URL),
  routes
})

function isLoggedIn() {
  return !!sessionManager.getSessionId()
}

router.beforeEach((to, from, next) => {
  const loggedIn = isLoggedIn()

  if (to.meta.requiresAuth && !loggedIn) {
    next({ path: '/', replace: true })
    return
  }

  if (to.meta.guestOnly && loggedIn) {
    next({ path: '/monitor', replace: true })
    return
  }

  next()
})

export default router
